/**
 * サバイバルモードのプレイヤーステータス
 */
export interface SurvivalStats {
  hp: number;
  strength: number;
  special: number;
  speed: number;
  toughness: number;
}

/**
 * サバイバルモードのセーブデータ
 */
export interface SurvivalSaveData {
  /** 使用キャラID */
  monsterId: string;
  /** 現在の連勝数 */
  winCount: number;
  /** 未使用のボーナスポイント */
  bonusPoints: number;
  /** プレイヤーの現在ステータス */
  stats: SurvivalStats;
  /** 次に戦う相手の順序（先頭が次の対戦相手） */
  opponentQueue: string[];
}

/**
 * セーブデータのバリデーション
 */
export function isValidSurvivalSaveData(obj: unknown): obj is SurvivalSaveData {
  if (!obj || typeof obj !== 'object') return false;
  const d = obj as Record<string, unknown>;
  if (typeof d.monsterId !== 'string') return false;
  if (typeof d.winCount !== 'number' || d.winCount < 0) return false;
  if (typeof d.bonusPoints !== 'number' || d.bonusPoints < 0) return false;
  if (!d.stats || typeof d.stats !== 'object') return false;
  const s = d.stats as Record<string, unknown>;
  for (const key of ['hp', 'strength', 'special', 'speed', 'toughness']) {
    if (typeof s[key] !== 'number') return false;
  }
  if (!Array.isArray(d.opponentQueue)) return false;
  if (d.opponentQueue.length === 0) return false;
  if (!d.opponentQueue.every((id: unknown) => typeof id === 'string')) return false;
  return true;
}
